
export const API = (import.meta.env.VITE_API_QUINIELA || '/api').trim();

export const SERVERPATH = (import.meta.env.VITE_SERVER_PATH || '/').trim();

export const paginacionOpciones = {
    rowsPerPageText: 'Elementos Por Pagina',
    rangeSeparatorText: 'de',
    selectAllRowsItem: false,
    selectAllRowsItemText: 'Todos'
}

export const seleccionMensaje = { singular: 'Elemento', plural: 'Elementos', message: 'Seleccionado(s)' }